import React, { useState, useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import pdf from "../../Assets/Zecheng_Zhang_resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
// import "./styles.css";
// import DocViewer, { DocViewerRenderers } from "react-doc-viewer"
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;



const resumeLink =
  // "https://raw.githubusercontent.com/beebus/portfolio/master/src/Assets/Resume_Michael_Beebower.pdf";
  // "https://raw.githubusercontent.com/Zhang-Zecheng/resume/main/Zecheng_Zhang_resume.pdf";
  // "https://drive.google.com/file/d/19-8_fpt-jEtEj5UCQW3wzNPgvdvND48F/view?usp=sharing";
  "https://drive.google.com/uc?export=download&id=19-8_fpt-jEtEj5UCQW3wzNPgvdvND48F";
  // https://raw.githubusercontent.com/Zhang-Zecheng/resume/Zecheng_Zhang_resume.pdf
  

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        <Row className="resume">
          <Document file={resumeLink}>
            <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
          </Document>
          {/* <DocViewer pluginRenderers={DocViewerRenderers} documents={docs} /> */}
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
